import {Skeleton} from '@molecules';

export const CalendarWeekDayLoader = () => {
  return (
    <div className="relative w-full h-28 bg-white">
      <Skeleton className="absolute top-6 left-5 w-16 h-[15px] bg-beige-200" />
      <Skeleton className="absolute top-6 right-5 w-11 h-[15px] bg-beige-200" />

      <Skeleton className="absolute bottom-3 left-5 w-[172px] h-[48px] bg-beige-200" />
      <Skeleton className="absolute bottom-5 right-5 w-[112px] h-[32px] bg-beige-200" />
    </div>
  );
};
